webpackJsonp([181568259120545],{

/***/ 1318:
/***/ (function(module, exports) {

	module.exports = {"data":{"contentfulIntegration":{"name":"Magento","slug":"magento","id":"c51Nc5zTYTKc4Ug0Yuouq4w","website":"https://magento.com","product":null}},"pathContext":{"slug":"magento"}}

/***/ })

});


// WEBPACK FOOTER //
// path---integration-magento-2bfea0ce2084d379e2d9.js